import { render, staticRenderFns } from "./ManangeTransfers.vue?vue&type=template&id=55bfc899&scoped=true"
import script from "./ManangeTransfers.vue?vue&type=script&lang=js"
export * from "./ManangeTransfers.vue?vue&type=script&lang=js"
import style0 from "./ManangeTransfers.vue?vue&type=style&index=0&id=55bfc899&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bfc899",
  null
  
)

export default component.exports